// Translation: Verification > Landing > Form (Russian)
export default Object.freeze({
	form: {
		actions: {
			verifyAccount: ''
		},
		fields: {
			code: {
				placeholder: ''
			}
		},
		options: {
			resendCode: {
				label: {
					idle: '',
					success: ''
				}
			}
		},
		title: ''
	}
})
